export default "__VITE_ASSET__3e1fd81f__"